import { SECURITY_GROUP_DEFAULT_NAME } from '@/common/constants/networks.constants';
import { IMAGE_TYPES } from '@/common/constants/images.constants';
import { CERTIFICATE_FILE_TYPE, PRIVATE_KEY_FILE_TYPE } from '@/common/constants/certificate.constants';

const ipTemplate = '(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

export const IP_V4_REGEXP = new RegExp(`^${ipTemplate}$`);

export const IP_V4_RANGE_REGEXP = new RegExp(`^(${ipTemplate})(?:\\s+)?-(?:\\s+)?(${ipTemplate})$`);

export const IP_V4_SUBNET_REGEXP = new RegExp(`^((${ipTemplate}(/([1-9]|[1-2][0-9]|3[0-2])))|(0\\.0\\.0\\.0/0))$`);

export const IP_V4_LIKE_REGEXP = /^(?:[0-9]{1,3}\.){1,3}[0-9]{1,3}$/;

export const IP_V6_CIDR = /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))$/;

export const MAC_REGEXP = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

export const MAC_PREFIX_REGEXP = /^[0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}([:-][0-9A-Fa-f]{2})?$/i;

export const MAC_NOT_MULTICAST = /^[0-9A-F][02468ACE][:-]([0-9A-F]{2}[:-]){4}([0-9A-F]{2})$/i;

export const IP_WITH_PORT_REGEXP = new RegExp(`^${ipTemplate}(:([1-5]\\d{4}|[1-9]\\d{0,3}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5]))?$`);

export const DOMAIN_REGEXP = /^(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9]*[A-Z][A-Z0-9]+\.?|[A-Z0-9]+[A-Z][A-Z0-9]*\.?)|localhost)$/i;

// from https://github.com/richb-intermapper/IPv6-Regex
export const IP_V6_REGEXP = /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/;

export const NOTARY_KEY = /^[A-Za-z0-9]{32}$/;

const int16bit = '([1-5]\\d{4}|[1-9]\\d{0,3}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5])';
const int16bitIncludeZero = '([0]|[1-5]\\d{4}|[1-9]\\d{0,3}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5])';

export const SINGLE_PORT_INCLUDE_ZERO = new RegExp(`^${int16bitIncludeZero}$`);

export const SINGLE_PORT = new RegExp(`^${int16bit}$`);

export const PORT_RANGE = new RegExp(`^${int16bit}(?:\\s+)?-(?:\\s+)?${int16bit}$`);

export const PORT_RANGE_INCLUDE_ZERO = new RegExp(`^${int16bitIncludeZero}(?:\\s+)?-(?:\\s+)?${int16bitIncludeZero}$`);

export const URL = new RegExp(
  '^'
  // protocol identifier
  + '(?:(?:https?|ftp)://)'
  // user:pass authentication
  + '(?:\\S+(?::\\S*)?@)?'
  + '(?:'
  // IP address dotted notation octets
  // excludes loopback network 0.0.0.0
  // excludes reserved space >= 224.0.0.0
  // excludes network addresses
  // (first of IP address each class)
  + '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])'
  + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}'
  + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-5]))'
  + '|'
  // host name
  + '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)'
  // domain name
  + '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*'
  // TLD identifier
  + '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))'
  // TLD may end with dot
  + '\\.?'
  + '|localhost'
  + ')'
  // port number
  + '(?::\\d{2,5})?'
  // resource path
  + '(?:[/?#]\\S*)?'
  + '$', 'i'
);

export const URL_WITHOUT_LOCALE = new RegExp(
  '^'
  // protocol identifier
  + '(?:(?:https?|ftp)://)'
  // user:pass authentication
  + '(?:\\S+(?::\\S*)?@)?'
  + '(?:'
  // IP address exclusion
  // private & local networks
  + '(?!(?:10|127)(?:\\.\\d{1,3}){3})'
  + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})'
  + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})'
  // IP address dotted notation octets
  // excludes loopback network 0.0.0.0
  // excludes reserved space >= 224.0.0.0
  // excludes network addresses
  // (first IP address of each class)
  + '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])'
  + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}'
  + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-5]))'
  + '|'
  // host name
  + '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)'
  // domain name
  + '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*'
  // TLD identifier
  + '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))'
  // TLD may end with dot
  + '\\.?'
  + ')'
  // port number
  + '(?::\\d{2,5})?'
  // resource path
  + '(?:[/?#]\\S*)?'
  + '$', 'i'
);

export const SECURITY_GROUP_NAME = new RegExp(`\\b(?!\\b${SECURITY_GROUP_DEFAULT_NAME}\\b)\\w+\\b`);

// from https://tools.ietf.org/html/rfc3722
export const ISCSI_TARGET_NAME = /^[a-z0-9.-]+$/;
export const ISCSI_IQN = /^iqn\.[\d]{4}-(?:0[1-9]|1[0-2])\.(?:[a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+(?::[a-z0-9.-]+)+$/;

export const ISCSI_CHAP_USER = /^[a-zA-Z0-9.:_-]{1,128}$/;

export const KUBERNETES_CLUSTER_NAME = /^(?!.*\s)[a-zA-Z][a-zA-Z0-9_.-]{1,254}$/;

export const STORAGE_POLICY_NAME = /^[\w.:()-][\w.:() -]{1,31}$/;

export const NETWORK_NAME = /^[a-zA-Z0-9_]{3,32}$/;

export const CLUSTER_NAME = /^[a-zA-Z][a-zA-Z0-9-]+[a-zA-Z0-9]$/;

export const NFS_EXPORT_NAME = /^[A-Za-z0-9/.\-_]+$/;

export const POSITIVE_INTEGER = /^\d+$/;

export const ALPHANUM = /^[a-zA-Z0-9]+$/;

export const ALPHANUM_EXTENDED = /^[\sA-z0-9_-]+$/;

export const IMAGE_FILE_EXTENSION = new RegExp(`\\.${Object.values(IMAGE_TYPES).flat().join('|')}$`, 'i');

export const CERT_FILE_EXTENSION = new RegExp(`(\\.${Object.values(CERTIFICATE_FILE_TYPE).join('|')})$`, 'i');

export const KEY_FILE_EXTENSION = new RegExp(`(\\.${Object.values(PRIVATE_KEY_FILE_TYPE).join('|')})$`, 'i');

export const PSK_REGEXP = /(?=.*?[0-9])(?=.*?[A-Za-z]).{16,}$/;

export const VM_PASSWORD_REGEXP = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+~?`-]).{12,}$/;

export const LICENSE_KEY_VIRTUOZZO = /^([A-Z0-9]{6}-){4}[A-Z0-9]{6}$/i;

export const LICENSE_KEY_ACRONIS = /^([A-Z0-9]{8}-){7}[A-Z0-9]{8}$/i;

const kubernetesKeyValuePair = '((((?!kubernetes.io|k8s.io)([A-Z0-9]|[A-Z0-9][A-Z0-9\\._-]{0,251})[A-Z0-9]\\/)?([A-Z0-9]|([A-Z0-9][A-Z0-9\\._-]{0,})[A-Z0-9])=("([^"\\\\]*(\\\\.[^"\\\\]*)*)"|[A-Z0-9]|([A-Z0-9][A-Z0-9\\._-]{0,})[A-Z0-9])?))';
export const KUBERNETES_LABELS_REGEXP = new RegExp(`^${kubernetesKeyValuePair}(,\\s?${kubernetesKeyValuePair})*$`, 'i');

export const DOMAIN_NAME_REGEXP = /^[^/?#]+$/;

export const NFS_SHARE_NAME_REGEXP = /^[-\w]+$/;

export const LINUX_ROOT_PATH = /^\/([^/ ]*\/?)+$/;

export const SSH_KEY_REGEXP = /(?:ssh-rsa AAAAB3NzaC1yc2|ecdsa-sha2-nistp256 AAAAE2VjZHNhLXNoYTItbmlzdHAyNT|ecdsa-sha2-nistp384 AAAAE2VjZHNhLXNoYTItbmlzdHAzODQAAAAIbmlzdHAzOD|ecdsa-sha2-nistp521 AAAAE2VjZHNhLXNoYTItbmlzdHA1MjEAAAAIbmlzdHA1Mj|ssh-ed25519 AAAAC3NzaC1lZDI1NTE5|ssh-dss AAAAB3NzaC1kc3).+\s(.+)\s?/;

// eslint-disable-next-line no-control-regex
export const NON_ASCII = /[^\x00-\x7F]/;

export const UUID_REGEXP = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$|^[0-9a-f]{32}$/;

export const BUCKET_NAME_REGEXP = /^[a-z0-9][a-z0-9-.]+[a-z0-9]$/;

export const S3_BUCKET_FOLDER_NAME = /^[^/]+$/;

export const COMPUTE_PORTS_NETWORK_DHCP_REGEXP = /dhcp[a-f0-9-]+-([a-f0-9-]{36})/;

export const EXTERNAL_STORAGE_NAME_REGEXP = /^[a-zA-Z]\w*$/;

export const NFS_VERSION_MOUNT_OPTIONS_REGEXP = /vers=(\d+(?:\.\d+)?)/;

export const IP_V4_OR_SUBNET_REGEXP = new RegExp(`^${ipTemplate}(/([0-9]|[1-2][0-9]|3[0-2]))?$`);

export const EXPORT_NAME_REGEXP = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9$])?$/;

export const VM_TAGS_REGEXP = /^[a-zA-Z0-9_-]+(, ?[a-zA-Z0-9_-]+)*$/;
